import { render, staticRenderFns } from "./AvukatSecim.vue?vue&type=template&id=bb084990&scoped=true"
import script from "./AvukatSecim.vue?vue&type=script&lang=ts"
export * from "./AvukatSecim.vue?vue&type=script&lang=ts"
import style0 from "./AvukatSecim.vue?vue&type=style&index=0&id=bb084990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb084990",
  null
  
)

export default component.exports